// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H22V7H19.0855L19.47 10H22V12H19.7264L21.119 22.8647L19.1353 23.119L17.71 12H6.25778L4.86824 23.1163L2.88369 22.8682L4.24222 12H2V10H4.49222L4.86722 7H2V2ZM6.88278 7L6.50778 10H11V7H6.88278ZM13 7V10H17.4537L17.0691 7H13Z"}}]};

const Archway1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'archway-1-filled',
    ref,
    icon: element,
  },
));

Archway1FilledIcon.displayName = 'Archway1FilledIcon';

export default Archway1FilledIcon;
